import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'input', 'name' ]

  connect() {
    var checkboxes = this.inputTargets,
    buttonNext = document.getElementById('button-next')
    console.log(checkboxes)
    for (var i=0; i<checkboxes.length; i++) {
      buttonNext.disabled = true
      if (checkboxes[i].checked === true){
        buttonNext.disabled = false
        break
      }
    }
  }

  required() {
    const checkboxes = this.inputTargets,
    buttonNext = document.getElementById('button-next')
    console.log(checkboxes)
    for (var i=0; i<checkboxes.length; i++) {
      buttonNext.disabled = true
      if (checkboxes[i].checked === true){
        buttonNext.disabled = false
        break
      }
    }
  }

  unchecked(el) {
    const checkboxes = this.inputTargets,
    element = el.target
    if (element.hasAttribute("data-reject-all") && element.checked === true) {
      for (var i=0; i<checkboxes.length - 1; i++) {
        checkboxes[i].checked = false
      } 
    } else if (element.hasAttribute("data-reject-one") && element.checked === true) {
      checkboxes[checkboxes.length - 1].checked = false
    }
  }
}